import styled from "styled-components"
import MainCompanyUser from "./component"

export default styled(MainCompanyUser)``